// Role-based permissions system
export const ROLES = {
  USER: 'User',
  STAFF: 'Staff',
  INSTRUCTOR: 'Instructor', 
  MANAGER: 'Manager',
  ADMINISTRATOR: 'Administrator',
  OWNER: 'Owner',
  MASTER: 'Master'
}

export const PERMISSIONS = {
  // Basic access
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_CALENDAR: 'view_calendar',
  VIEW_EVENTS: 'view_events',
  
  // Customer management
  VIEW_CUSTOMERS: 'view_customers',
  MANAGE_CUSTOMERS: 'manage_customers',
  
  // Staff management
  VIEW_STAFF: 'view_staff',
  MANAGE_STAFF: 'manage_staff',
  
  // Reports and analytics
  VIEW_REPORTS: 'view_reports',
  VIEW_ADVANCED_REPORTS: 'view_advanced_reports',
  
  // Transport management
  VIEW_TRANSPORT: 'view_transport',
  MANAGE_TRANSPORT: 'manage_transport',
  
  // Settings and configuration
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_SYSTEM_CONFIG: 'manage_system_config',

  // Administration
  VIEW_ADMIN_PANEL: 'view_admin_panel',
  MANAGE_USERS: 'manage_users',
  VIEW_SYSTEM_LOGS: 'view_system_logs'
}

const rolePermissions = {
  [ROLES.USER]: [],
  
  [ROLES.STAFF]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_CALENDAR,
    PERMISSIONS.VIEW_EVENTS
  ],
  
  [ROLES.INSTRUCTOR]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_CALENDAR,
    PERMISSIONS.VIEW_EVENTS
  ],
  
  [ROLES.MANAGER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_CALENDAR,
    PERMISSIONS.VIEW_EVENTS,
    PERMISSIONS.VIEW_CUSTOMERS,
    PERMISSIONS.MANAGE_CUSTOMERS,
    PERMISSIONS.VIEW_STAFF,
    PERMISSIONS.MANAGE_STAFF,
    PERMISSIONS.VIEW_TRANSPORT,
    PERMISSIONS.MANAGE_TRANSPORT,
    //PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.MANAGE_SETTINGS
  ],
  
  [ROLES.ADMINISTRATOR]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_CALENDAR,
    PERMISSIONS.VIEW_EVENTS,
    PERMISSIONS.VIEW_CUSTOMERS,
    PERMISSIONS.MANAGE_CUSTOMERS,
    PERMISSIONS.VIEW_STAFF,
    PERMISSIONS.MANAGE_STAFF,
    PERMISSIONS.VIEW_TRANSPORT,
    PERMISSIONS.MANAGE_TRANSPORT,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.VIEW_ADVANCED_REPORTS,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_SYSTEM_CONFIG,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.VIEW_SYSTEM_LOGS
  ],
  
  [ROLES.OWNER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_CALENDAR,
    PERMISSIONS.VIEW_EVENTS,
    PERMISSIONS.VIEW_CUSTOMERS,
    PERMISSIONS.MANAGE_CUSTOMERS,
    PERMISSIONS.VIEW_STAFF,
    PERMISSIONS.MANAGE_STAFF,
    PERMISSIONS.VIEW_TRANSPORT,
    PERMISSIONS.MANAGE_TRANSPORT,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.VIEW_ADVANCED_REPORTS,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.MANAGE_SYSTEM_CONFIG,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.VIEW_SYSTEM_LOGS
  ],
  
  [ROLES.MASTER]: [
    ...Object.values(PERMISSIONS)
  ]
}

export function hasPermission(userRole, permission) {
  if (!userRole || !permission) return false
  return rolePermissions[userRole]?.includes(permission) || false
}

export function hasAnyPermission(userRole, permissions) {
  if (!userRole || !permissions?.length) return false
  return permissions.some(permission => hasPermission(userRole, permission))
}

export function getRolePermissions(role) {
  return rolePermissions[role] || []
}

export function canAccessRoute(userRole, routeName) {
  const routePermissions = {
    'Daily': [PERMISSIONS.VIEW_DASHBOARD],
    'Calendar': [PERMISSIONS.VIEW_CALENDAR],
    'Event List': [PERMISSIONS.VIEW_EVENTS],
    'List Customer': [PERMISSIONS.VIEW_CUSTOMERS],
    'Staff List': [PERMISSIONS.VIEW_STAFF],
    'Transport List': [PERMISSIONS.VIEW_TRANSPORT],
    'User Dashboard': [PERMISSIONS.VIEW_REPORTS],
    'Admin Dashboard': [PERMISSIONS.VIEW_ADMIN_PANEL],
    'Settings': [PERMISSIONS.MANAGE_SETTINGS]
  }
  
  const requiredPermissions = routePermissions[routeName]
  if (!requiredPermissions) return true // Allow access to routes without specific permissions
  
  return hasAnyPermission(userRole, requiredPermissions)
}